import { createFileRoute } from '@tanstack/react-router';

import { collectionDebtorScreen, debtorSearch, loadCollectionMessages, loadCollectionScreens } from '@/modules/collection/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

export const Route = createFileRoute('/_app/gestao-carteira/recuperacao/devedor/$installmentId')({
  validateSearch: debtorSearch,
  staticData: { screen: collectionDebtorScreen },
  loader: () => loadCollectionMessages(),
  component: lazyScreen(loadCollectionScreens, 'CollectionDebtorRouteScreen'),
});
